export interface PosModifierOption {
  id: string;
  name: string;
  price: number;
}

const DEFAULT_MODIFIERS: PosModifierOption[] = [
  { id: 'extra-cheese', name: 'Extra cheese', price: 30 },
  { id: 'extra-sauce', name: 'Extra sauce', price: 15 },
  { id: 'no-onion', name: 'No onion', price: 0 },
  { id: 'large-size', name: 'Large size', price: 50 },
  { id: 'spicy', name: 'Extra spicy', price: 10 },
];

function key(storeId: number) {
  return `saaspos_modifiers_${storeId}`;
}

export function loadStoreModifiers(storeId: number): PosModifierOption[] {
  try {
    const raw = localStorage.getItem(key(storeId));
    if (raw) return JSON.parse(raw) as PosModifierOption[];
  } catch {
    /* ignore */
  }
  return DEFAULT_MODIFIERS;
}

export function isFbModifiersEnabled(storeId: number): boolean {
  return localStorage.getItem(`saaspos_fb_mode_${storeId}`) === 'true';
}

export function setFbModifiersEnabled(storeId: number, enabled: boolean) {
  localStorage.setItem(`saaspos_fb_mode_${storeId}`, enabled ? 'true' : 'false');
}

export function saveStoreModifiers(storeId: number, modifiers: PosModifierOption[]) {
  localStorage.setItem(key(storeId), JSON.stringify(modifiers));
}
